define('views/modules/calendar/calendar/calendar-component/item/item-delete-modal',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    'services/i18n',
    // events
    'services/events/calendar-events',
    // model
    'models/calendar/session',
    // views
    'views/parts/modal/modal',
    'views/parts/form/choices',
    // templates
    'text!templates/modules/calendar/calendar/calendar-component/item/item-delete-modal.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // src
    i18n,
    // events
    CalendarEvents,
    // model
    MSession,
    // views
    VModal,
    VChoices,
    // templates
    TCalendarItemDeleteModal
) {

    var VCalendarItemDeleteModal = VModal.extend({
        template: TCalendarItemDeleteModal,

        regions: {
            checkbox: ".delete-session",
        },

        modal: function() {
            return {
                title: i18n.t("calendar:Delete a calendar item"),
                // size: "small",
                className: "calendar-item-delete-modal",
            };
        },

        initialize: function(options) {
            options = options || {}; // additional options passed to the constructor.
            this.view = {
                checkbox: new VChoices({ label: "calendar:Delete all items of the animated session" }),
            };
        },

        render: function() {
            var html = Mustache.render(this.template, Mustache.getContext(this.model.toJSON()));
            this.$el.empty().append(html);
            this.generateZones();

            if (this.model.getType() === "animated") this.assign(this.view.checkbox, this.zone.$checkbox);

            this.renderModal();

            return this;
        },

        isDeletingSession: function() {
            return this.view.checkbox.getValue();
        },

        setModel: function(model) {
            this.model = model;
            this.view.checkbox.setValue(false);
            return this;
        },

        ////////////
        // events //
        ////////////
        onConfirm: function(confirmed) {
            if (!confirmed) return;
            if (this.isDeletingSession()) {
                var session = new MSession();
                session.setId(this.model.get('session'));
                session.destroy({
                    success: this.onSessionDestroy,
                    context: this
                });
            } else {
                this.model.destroy({ autofixRelated: true });
            }
        },

        onSessionDestroy: function() {
            CalendarEvents.sessionDestroyed(this.model.get('session'));
        },

    });

    return VCalendarItemDeleteModal;
});

